import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 是否为公有云环境
    isCloud: process.env.VUE_APP_IS_CLOAD === 'true',
    username: '',
    alertTypeArr: [],
    // 系统主题
    theme: 'default',
    countNum: 0,
    accetpVoice: [],
    helpShow: true,
    // 语音组件显示状态
    voiceShow: false,
    // 对讲组件显示状态
    walkieShow: false,
    // 新语音提醒显示状态
    showTip: false,
    sosVoice: [],
    // 安全帽状态对象
    helmetStatusObj: {},
    // 录像提示音等属性设置对象
    vidiconObj: {},
    // 实时视频打开弹框对象
    helpInfo: {},
    // 判断ws 是否为该用户发出的请求（不同用户切换分辨率时用到）
    isUserSend: false,
    // 判断是否打开视频，用于超时退出
    openVedio: false,
    handleresolutionP: '',
    isCancelOne: true,
    // 实时视频海报样式
    posterFlag: false,
    // 实时视频时是否收到了房间号
    hasRoomId: false,
    // 实时视频时是否本地推流回调成功
    isLocalStreamPublish: false,
    // 是否静音状态
    isTrtcMuted: true,
    trailIndex: '',
    trailData: [],
    // 新版H5头盔信息
    jlsHelmetInfo: {},
    // 新版H5轨迹信息
    jlstrailData: [],
    // 新版H5轨迹信息
    jlstrailIndex: '',
    //  jls轨迹播放相关
    jlsPlayTrack: false,
    //  jls显示轨迹记录
    jlsTrackList: false,
    // 新版H5头盔体征信息信息
    jlsSignInfo: {},
    isPlayTrail: false,
    //  H6轨迹播放相关
    isPlayTrack: false,
    // 导航index
    currentIndex: '',
    // 当前选中头盔的数据
    currentHelmetData: {
      deviceName: '',
      userId: '',
      serialNumber: '',
      positionName: '-',
    },
    // 是否是求助状态
    isEmergency: false,
    // 是否是本机发送语音对讲
    isLocalWalkie: false,
    // 是否抢占监控
    isPreempt: false,
    trailQuery: null,
    trailPageNum: 1,
    trailTotal: 0,
    centerPoint: {
      lat: 23.14666,
      lng: 113.34166,
    },
    // 当前租户支持的设备型号
    deviceSpecModel: '',
    // 当前租户支持的设备类型
    // 值可能为"0,1,2,3"  注意：顺序可能为乱序
    deviceSpecType: '',
    openWaike: false,
    // 正在语音通话信息
    waikeInfo: {},
    // 正常按钮关闭
    waikeNormalClose: true,
    helpVideo: false,
    // 调用百度翻译后缓存
    bdTranslate: {},
    // 直播模式，目前支持 FLV, WEBRTC
    liveMode: '',
    // 系统相关配置，环境变量初始化配置，可通过config.js二次修改
    systemConfig: {},
    // 精准调度table
    showHelmetTable: false,
    // 精准调度数据列表查询参数
    userTreeQuery: {},
    // 多个端登录同一个账户区分语音通话
    voiceCallCurrent: '',
    // 电子围栏地图类型
    fenceMapType: '',
    changeBdTranslate:{},
    systemPath: '',
    openRealeVideo: false,
    // 正在实时视频信息
    videoInfo: {},
    videoItem: {},
     // 单点登录是否显示头部菜单
     headerCollapse: 'true',
     footCollapse: 'true',
  },
  getters: {
    // 是否为公有云环境
    isCloud: state => state.isCloud,
    // 是否为默认主题， theme=default=浅色样式、theme=dark=深色样式
    isDefaultTheme: state => {
      return state.theme === 'default'
    },
    // 是否为暗色主题
    isDarkTheme: state => {
      return state.theme !== 'default'
    },
    // 实时音视频服务类型，默认为腾讯云实时音视频 trtc
    rtcType: state => {
      return state.systemConfig.rtcType || 'trtc'
    },
    // 系统是否仅支持IPC设备
    isOnlySupportIPC: state => {
      return state.deviceSpecType === '3'
    },
    // 系统是否支持智能帽衬
    isSupportIH5: state => {
      return state.deviceSpecType.includes('0')
    },
    // 设备类型数组，格式： [1,2,3,4]
    deviceSpecTypeArray: state => {
      return state.deviceSpecType.split(',')
    },
    // 系统是否使用快直播模式,若未配置默认为快直播（WEBRTC）
    isQuickLive: state => {
      return state.liveMode !== 'FLV'
    },
    // 系统是否仅支持智能帽衬设备
    isOnlySupportIH5: state => {
      return state.deviceSpecType === '0'
    },
    mediasoupWsUrl: state => {
      return state.systemConfig.mediasoupWsUrl || ''
    },
    srsWsUrl: state => {
      return state.systemConfig.srsWsUrl || ''
    },
    innerIp: state => {
      return state.systemConfig.innerIp || ''
    },
    outerIp: state => {
      return state.systemConfig.outerIp || ''
    },
    // 系统是否仅支持智能帽衬设备
    isOnlySupportPosition: state => {
      return state.deviceSpecType === '4'
    },
    showSystemPath: state => {
      return state.systemPath || ''
    },
    showHeaderCollapse: state => {
      return state.headerCollapse === 'true'
    },
    showFootCollapse: state => {
      return state.footCollapse === 'true'
    },
  },
  mutations: {
    changeHeaderCollapse(state, val) {
      state.headerCollapse = val
    },
    changeFootCollapse(state, val) {
      state.footCollapse = val
    },
    setfenceMapType(state, val) {
      state.fenceMapType = val
    },
    setVoiceCallCurrent(state, val) {
      state.voiceCallCurrent = val
    },
    setTreeQuery(state, val) {
      state.userTreeQuery = val
    },
    setHelpVideo(state, val) {
      state.helpVideo = val
    },
    waikeNormalClose(state, val) {
      state.waikeNormalClose = val
    },
    savewaikeInfo(state, val) {
      state.waikeInfo = val
    },
    openWaike(state, val) {
      state.openWaike = val
    },
    handleCenterPoint(state, val) {
      state.centerPoint = val
    },
    handleIsPreempt(state, val) {
      state.isPreempt = val
    },
    handleIsLocalStreamPublish(state, val) {
      state.isLocalStreamPublish = val
    },
    handleIsLocalWalkie(state, val) {
      state.isLocalWalkie = val
    },
    handleIsEmergency(state, val) {
      state.isEmergency = val
    },
    handleIsTrtcMuted(state, val) {
      state.isTrtcMuted = val
    },
    /**
     * 设置是否收到了房间号
     * @param {*} val 布尔值
     */
    handleHasRoomId(state, val) {
      state.hasRoomId = val
    },
    handleresolutionP(state, val) {
      state.handleresolutionP = val
    },
    openVedio(state, val) {
      state.openVedio = val
    },
    /**
     *用于视频发出请求
     * @param {*} val 布尔值
     */
    userSend(state, val) {
      state.isUserSend = val
    },
    changeHelpInfo(state, val) {
      state.helpInfo = val
    },
    changeVidiconObj(state, val) {
      state.vidiconObj = val
    },
    changeHelmetStatusObj(state, val) {
      state.helmetStatusObj = val
    },
    /**
     * 设置安全帽拍照状态为正在拍照
     * @param {*} val 安全帽序列号
     */
    changeHelmetPhotoStatusOn(state, val) {
      if (state.helmetStatusObj[val]) {
        // 1代表正在拍照
        state.helmetStatusObj[val].photo = '1'
      }
    },
    alterUserName(state, val) {
      state.username = val
    },
    addAlertTypeArr(state, val) {
      state.alertTypeArr = val
    },
    /**
     * 切换主题
     */
    switchTheme(state,val) {
      // state.theme = state.theme === 'default' ? 'dark' : 'default'
      Vue.set(state,'theme',val)
    },
    emptyUserName(state) {
      state.username = ''
    },
    countNum(state) {
      state.countNum = state.countNum + 1
    },
    sendVoice(state, val) {
      state.accetpVoice = val
    },
    changeShow(state, val) {
      state.helpShow = val
    },
    voiceShow(state, val) {
      state.voiceShow = val
    },
    walkieShow(state, val) {
      state.walkieShow = val
    },
    isCancelOne(state, val) {
      state.isCancelOne = val
    },
    /**
     *用于清除store 缓存
     * @param {*} state 所有的值
     */
    clear(state) {
      for (let i in state) {
        delete state[i]
      }
    },
    /**
     *用于有新语音显示提示
     * @param {*} val 布尔值
     */
    showTip(state, val) {
      state.showTip = val
    },
    sendSos(state, val) {
      state.sosVoice = val
    },
    changePosterFlag(state, val) {
      state.posterFlag = val
    },
    updatePlayTrail(state, val) {
      state.isPlayTrail = val
    },
    isPlayTrack(state, val) {
      state.isPlayTrack = val
    },
    currentHelmetData(state, val) {
      state.currentHelmetData = val
    },
    ExitjlsHelmetInfo(state, val) {
      state.jlsHelmetInfo = val
    },
    currentIndex(state, val) {
      state.currentIndex = val
    },
    ExitJlsTrailData(state, val) {
      state.jlstrailData = val
    },
    ExitJlsTrailIndex(state, val) {
      state.jlstrailIndex = val
    },
    jlsPlayTrack(state, val) {
      state.jlsPlayTrack = val
    },
    jlsTrackList(state, val) {
      state.jlsTrackList = val
    },
    jlsSignInfo(state, val) {
      state.jlsSignInfo = val
    },
    updateTrailIndex(state, val) {
      state.trailIndex = val
    },
    updateTrailData(state, val) {
      state.trailData = val
    },
    updateTrailQuery(state, val) {
      state.trailQuery = val
    },
    updateTrailPageNum(state, val) {
      state.trailPageNum = val
    },
    updateTrailTotal(state, val) {
      state.trailTotal = val
    },
    changeDeviceSpecModel(state, val) {
      state.deviceSpecModel = val
    },
    changeDeviceSpecType(state, val) {
      state.deviceSpecType = val
    },
    changeLiveMode(state, val) {
      state.liveMode = val
    },
    changeSystemConfig(state, val) {
      state.systemConfig = val
    },
    handleshowHelmetTable(state, val) {
      state.showHelmetTable = val
    },
    changeSystem(state, val) {
      state.systemPath = val
    },
    changeVideoInfo(state, val) {
      state.videoInfo = val
    },
    changeVideoItem(state, val) {
      state.videoItem = val
    },
    changeOpenVideo(state, val) {
      state.openRealeVideo = val
    },
  },
  actions: {
    alterName(context, val) {
      context.commit('alterUserName', val)
    },
    emptyUserName(context) {
      context.commit('emptyUserName')
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return val
      },
    }),
  ],
})

export default store
